import PropTypes from "prop-types";
import React from "react";
import Image from "../image/Image";
import { getImageLink } from "../../../utils/images";
import { decodeText } from "../../../utils/richText";
import { getChildNodes } from "../../../utils/nodes";

const FooterIconItems = ({ title, node }) => {
    const items = getChildNodes(node).filter((item) => item.title);

    if (!items.length) return null;

    return (
        <div className="footer-icon-items">
            <h4 className="footer-icon-items__title">{title}</h4>
            <ul className="footer-icon-items__list">
                {items.map((item, idx) => (
                    <li key={idx} className="footer-icon-items__item">
                        {getImageLink(item.image) && <Image imageNode={item.image} className="footer-icon-items__icon" />}
                        <span>{decodeText(item.title)}</span>
                    </li>
                ))}
            </ul>
        </div>
    );
};

FooterIconItems.propTypes = {
    title: PropTypes.string,
    node: PropTypes.object,
};

export default FooterIconItems;
